export default __webpack_public_path__ + "static/media/logo.b888f171.svg";